<template>
	<div class="">
		<!-- <div class="dark-mark"></div> -->
		<div class="message-box">
			<!-- <transition name="message" enter-active-class="fadeInDown animated transition-02s" leave-active-class="fadeOutUp animated transition-02s"> -->
				<div style="display: flex;align-items: center;background-color: #fff;padding: 0.5rem 1rem;box-shadow:0 10px 10px rgba(0, 0, 0, 0.1);border-radius: 0.2rem;" class="fadeIn animated transition-02s">
					<img src="../assets/imgs/message-info.svg" class="message-icon" v-if="message.type==1">
					<img src="../assets/imgs/message-success.svg" class="message-icon" v-if="message.type==2">
					<img src="../assets/imgs/message-error.svg" class="message-icon" v-if="message.type==3">
					<span style="display: flex;flex-wrap: wrap;max-width: 25rem;">{{message.msg}}</span>
				</div>
			<!-- </transition>	 -->
		</div>
	</div>
</template>

<script>
		import axios from 'axios'
		import {baseUrl} from '../assets/js/public.js'
		export default {
			data() {
				return {
				}
			},
			props:{
				message:{
					// 1.消息 2.成功 3.失败
					type:'',
					msg:''
				}
			},
			components: {
			},
			filters: {
	        },
			methods: {
			},
			mounted() {
			}
		}
</script>

<style lang="scss" scoped>
	.message-box{
		position: fixed;left: 0;right: 0;top: 3rem;display: flex;align-items: center;z-index: 9999;justify-content: center;
	}
	.message-icon{
		width: 1.5rem;height: 1.5rem;margin-right: 0.5rem;
	}
	
	.transition-02s{
		overflow: hidden;
		animation-duration: 0.4s;
	}
</style>